document.addEventListener('DOMContentLoaded', () => {
  // Function to check if all remaining cart items are gwps
  const areCartItemsGWPs = () => {
    const isGWPElements = document.querySelectorAll('form#cart td.cart-item__details .cart-item__is-gwp');

    // If we can't find any is_gwp nodes, avoid clearing the cart.
    if (isGWPElements.length === 0) return false;

    // Each .cart-item__is-gwp span contains the text 'true' or 'false'.
    // Consider an item a GWP only if the value (or data attribute) is the literal 'true'.
    return Array.from(isGWPElements).every((isGWPEl) => {
      const raw = (isGWPEl.dataset && isGWPEl.dataset.is_gwp) || isGWPEl.textContent || '';
      return String(raw).trim().toLowerCase() === 'true';
    });
  };

  // Function to clear the cart
  const clearCart = async () => {
    console.log('All remaining cart items are free. Clearing cart...');
    try {
      const response = await fetch('/cart/clear', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });
      if (response.ok) {
        console.log('Cart cleared successfully.');
        // Reload to ensure cart UI and any server-side state are synced.
        window.location.reload();
      } else {
        console.error('Failed to clear cart:', response.statusText);
      }
    } catch (error) {
      console.error('Error clearing cart:', error);
    }
  };

  // Mutation Observer to watch for changes in the cart
  const cartContainer = document.querySelector('form#cart');
  if (cartContainer) {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.removedNodes.length > 0) {
          console.log('Cart item removed. Checking if all remaining items are free.');
          // Small delay to allow the theme to update price nodes after removal.
          setTimeout(() => {
            if (areCartItemsGWPs()) {
              clearCart();
            }
          }, 100);
          break;
        }
      }
    });

    observer.observe(cartContainer, { childList: true, subtree: true });
    console.log('MutationObserver set up for cart changes.', cartContainer);
  } else {
    console.warn('Cart container (form#cart) not found. Cart monitoring script not active.');
  }
});
